<ng-container *ngIf="stackName">
  <div
    class="header-menu-item cursor-pointer position-relative d-inline-block mr-2 badge-position"
    (mouseover)="isHoveredNotification = true"
    (mouseout)="isHoveredNotification = false"
    [nbPopover]="popoverTemplate"
    (click)="onClickHandleEvent()"
    nbPopoverTrigger="click"
  >
    <nb-icon
      pack="eva"
      [status]="isHoveredNotification ? 'control' : 'primary'"
      icon="bell-outline"
    ></nb-icon>
    <nb-badge
      *ngIf="notificationCount > 0"
      [text]="notificationCount"
      status="danger"
      class="alert-count weight-600"
    >
    </nb-badge>
  </div>
  <ng-template #popoverTemplate>
    <nb-card
      class="mb-0"
      style="width: 32rem"
      [nbSpinner]="loadingNotification"
    >
      <nb-card-header
        class="pb-0 mb-0 d-flex justify-content-between align-items-center"
      >
        <span>Activity (Past 7 days)</span>
      </nb-card-header>
      <nb-card-body class="pb-0 h-100 pl-0 pr-0">
        <nb-tabset style="scrollbar-width: none">
          <nb-tab tabTitle="Release Failure" class="p-0 m-0">
            <nb-list *ngIf="!showEmpty" class="notification-list">
              <nb-list-item
                *ngFor="let notification of notifications"
                class="pl-0 ml-0 cursor-pointer"
                (click)="navigateToEnvironment(notification)"
              >
                <div class="ml-2">
                  <div>
                    <b [style.color]="notification.notificationColor">{{
                      notification.notificationMessage
                    }}</b>
                    in environment
                    <b class="color-primary-100">{{
                      notification.environmentName
                    }}</b>
                  </div>
                  <small
                    >{{ notification.triggeredDate | timeago }} by
                    {{ notification.userTriggered }}
                  </small>
                </div>
              </nb-list-item>
            </nb-list>
            <div
              *ngIf="showEmpty"
              class="d-flex flex-column align-items-center justify-content-center text-center p-4"
              style="height: 23rem"
            >
              <img
                src="assets/open-empty-box.svg"
                class="align-items"
                style="width: 6rem"
              />
              <h3 class="text-center mt-4">No Notifications Yet</h3>
              <p class="text-center">
                There are no release failures in this project.
              </p>
            </div>
          </nb-tab>
        </nb-tabset>
      </nb-card-body>
    </nb-card>
  </ng-template>
</ng-container>
